export enum UomConversionStatus {
  EXISTS = 'exists',
  MISSING = 'missing',
  NO_BASE_UOM = 'no_base_uom',
  NO_CORPORATE_PART = 'no_corporate_part',
  NO_EXTRACTED_UOM = 'no_extracted_uom',
  SAME_AS_BASE = 'same_as_base',
}
